import request from '../shared/http';
import appConfig from '../shared/js/app-config';

class FormFlowService {
  async listForms(serviceId = appConfig.getServiceId()) {
    const url = `/forms/${serviceId}`;
    const data = await request.get(url);
    return Array.isArray(data.data) ? data.data : [];
  }

  async getForm(id) {
    const url = `/forms/detail/${id}`;
    const response = await request.get(url);
    return response.data;
  }

  async createDraft(payload, serviceId = appConfig.getServiceId()) {
    const url = `/forms/${serviceId}`;
    return request.post(url, payload);
  }

  async updateDraft(id, payload) {
    const url = `/forms/${id}`;
    return request.put(url, payload);
  }

  async publish(id) {
    const url = `/forms/${id}/publish`;
    return request.post(url);
  }

  async revertToDraft(id) {
    const url = `/forms/${id}/draft`;
    return request.post(url);
  }

  async deleteForm(id) {
    const url = `/forms/${id}`;
    return request.delete(url);
  }
}

export default new FormFlowService();
